module.exports = __webpack_public_path__ + "img/rocket-heading-for-the-moon-5272600-4411742.edda7cdc.png";